'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 20px;\n    border-radius: ', ';\n    border: 1px solid ', ';\n    margin: 10px;\n'], ['\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 20px;\n    border-radius: ', ';\n    border: 1px solid ', ';\n    margin: 10px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../constants/colors');

var _radius = require('../../constants/radius');

var _alignments = require('../../constants/alignments');

var _sizes = require('../../constants/sizes');

var _container = require('../../layouts/container');

var _container2 = _interopRequireDefault(_container);

var _grid = require('../../layouts/grid');

var _grid2 = _interopRequireDefault(_grid);

var _row = require('../../layouts/row');

var _row2 = _interopRequireDefault(_row);

var _column = require('../../layouts/column');

var _column2 = _interopRequireDefault(_column);

var _header = require('../../atoms/text/header');

var _header2 = _interopRequireDefault(_header);

var _label = require('../../atoms/text/label');

var _label2 = _interopRequireDefault(_label);

var _addButton = require('../../atoms/buttons/addButton');

var _addButton2 = _interopRequireDefault(_addButton);

var _primaryButton = require('../../atoms/buttons/primaryButton');

var _primaryButton2 = _interopRequireDefault(_primaryButton);

var _secondaryButton = require('../../atoms/buttons/secondaryButton');

var _secondaryButton2 = _interopRequireDefault(_secondaryButton);

var _deleteButton = require('../../atoms/buttons/deleteButton');

var _deleteButton2 = _interopRequireDefault(_deleteButton);

var _formEditButton = require('../../atoms/buttons/formEditButton');

var _formEditButton2 = _interopRequireDefault(_formEditButton);

var _formViewButton = require('../../atoms/buttons/formViewButton');

var _formViewButton2 = _interopRequireDefault(_formViewButton);

var _formDownloadButton = require('../../atoms/buttons/formDownloadButton');

var _formDownloadButton2 = _interopRequireDefault(_formDownloadButton);

var _formUploadButton = require('../../atoms/buttons/formUploadButton');

var _formUploadButton2 = _interopRequireDefault(_formUploadButton);

var _actionModal = require('../modals/actionModal');

var _actionModal2 = _interopRequireDefault(_actionModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ItemContainer = (0, _styledComponents2.default)(_container2.default)(_templateObject, _radius.Radius.large, _colors.Colors.cello45);

var Sortable = function (_Component) {
    _inherits(Sortable, _Component);

    function Sortable(props) {
        _classCallCheck(this, Sortable);

        var _this = _possibleConstructorReturn(this, (Sortable.__proto__ || Object.getPrototypeOf(Sortable)).call(this, props));

        _this.arrayMove = function (arr, fromIndex, toIndex) {
            var element = arr[fromIndex];
            arr.splice(fromIndex, 1);
            arr.splice(toIndex, 0, element);
            return arr;
        };

        _this.state = {
            editing: false
        };
        return _this;
    }

    _createClass(Sortable, [{
        key: 'getDeleteButton',
        value: function getDeleteButton(index, code) {
            var _this2 = this;

            return _react2.default.createElement(_actionModal2.default, {
                size: 'small',
                toggle: _react2.default.createElement(_deleteButton2.default, { clickEvent: function clickEvent() {} }),
                items: _react2.default.createElement(_label2.default, { text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Sortable.areYouSure' }) }),
                actionButtons: [{
                    text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Sortable.no' }),
                    clickEvent: function clickEvent() {},
                    primary: false
                }, {
                    text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Sortable.yes' }),
                    clickEvent: function clickEvent() {
                        _this2.props.deleteEvent(index, code);
                    },
                    primary: true
                }]
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(_header2.default, { size: _sizes.Sizes.lg, text: this.props.header, textAlign: _alignments.Alignments.left, left: _sizes.Sizes.xs, top: _sizes.Sizes.md, bottom: _sizes.Sizes.md }),
                _react2.default.createElement(
                    _container2.default,
                    { fullSize: this.props.fullSize, verticalAlignment: _alignments.Alignments.bottom, horizontalAlignment: _alignments.Alignments.right, right: _sizes.Sizes.xs },
                    this.props.allowEdit && !this.state.editing && _react2.default.createElement(_formEditButton2.default, { clickEvent: function clickEvent() {
                            _this3.setState({ editing: true });
                        } })
                ),
                this.props.items && this.props.items.length > 0 && this.props.items.map(function (item, index) {
                    var code = item.code;
                    var editable = _this3.props.allowEdit;
                    if (_this3.props.itemEdit) {
                        editable = _this3.props.itemEdit(item);
                    }
                    if (_this3.props.codeProperty) code = item[_this3.props.codeProperty];
                    return _react2.default.createElement(
                        ItemContainer,
                        { key: code || item.code },
                        _react2.default.createElement(
                            _grid2.default,
                            null,
                            _react2.default.createElement(
                                _row2.default,
                                null,
                                _react2.default.createElement(
                                    _column2.default,
                                    { xs: 8 },
                                    _react2.default.createElement(
                                        _container2.default,
                                        { verticalAlignment: _alignments.Alignments.Center, fullSize: true },
                                        _react2.default.createElement(_label2.default, { text: _this3.props.labelEvent(code, index, item), textAlign: _alignments.Alignments.left })
                                    )
                                ),
                                _react2.default.createElement(
                                    _column2.default,
                                    { xs: 1 },
                                    index !== 0 && _this3.state.editing && _react2.default.createElement(_formUploadButton2.default, { clickEvent: function clickEvent() {
                                            var items = _this3.props.items;
                                            items = _this3.arrayMove(items, index, index - 1);
                                            _this3.props.sortEvent(items);
                                        } })
                                ),
                                _react2.default.createElement(
                                    _column2.default,
                                    { xs: 1 },
                                    index < _this3.props.items.length - 1 && _this3.state.editing && _react2.default.createElement(_formDownloadButton2.default, { clickEvent: function clickEvent() {
                                            var items = _this3.props.items;
                                            items = _this3.arrayMove(items, index, index + 1);
                                            _this3.props.sortEvent(items);
                                        } })
                                ),
                                _react2.default.createElement(
                                    _column2.default,
                                    { xs: 1 },
                                    _this3.props.allowDelete && _this3.state.editing && editable && _this3.getDeleteButton(index, code)
                                ),
                                _react2.default.createElement(
                                    _column2.default,
                                    { xs: 1 },
                                    (_this3.state.editing && editable) === true && _react2.default.createElement(_formEditButton2.default, { clickEvent: function clickEvent() {
                                            _this3.props.editEvent(index, code);
                                        } }),
                                    _this3.state.editing === false && _react2.default.createElement(_formViewButton2.default, { clickEvent: function clickEvent() {
                                            _this3.props.editEvent(index, code);
                                        } })
                                )
                            )
                        )
                    );
                }),
                this.props.allowAdd === true && this.state.editing && _react2.default.createElement(
                    ItemContainer,
                    null,
                    _react2.default.createElement(_addButton2.default, { clickEvent: function clickEvent() {
                            var items = _this3.props.items;
                            if (!items) items = [];
                            var code = '' + _this3.props.defaultCode(items.length + 1);
                            var item = {};
                            if (_this3.props.codeProperty) {
                                item[_this3.props.codeProperty] = code;
                            } else {
                                item.code = code;
                            }
                            items.push(item);
                            _this3.props.addEvent(items);
                        } })
                ),
                this.state.editing && _react2.default.createElement(
                    _container2.default,
                    { inline: true, top: _sizes.Sizes.xs, bottom: _sizes.Sizes.xs, left: _sizes.Sizes.xs },
                    _react2.default.createElement(_primaryButton2.default, {
                        text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Sortable.save' }),
                        right: _sizes.Sizes.xs,
                        clickEvent: function clickEvent() {
                            _this3.props.saveEvent();
                            _this3.setState({ editing: false });
                        } }),
                    _react2.default.createElement(_secondaryButton2.default, {
                        text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Sortable.cancel' }),
                        clickEvent: function clickEvent() {
                            _this3.props.cancelEvent();
                            _this3.setState({ editing: false });
                        },
                        right: _sizes.Sizes.xs })
                )
            );
        }
    }]);

    return Sortable;
}(_react.Component);

exports.default = Sortable;